module.exports = __webpack_public_path__ + "img/boton-01.0569a5b6.png";